<template>
  <div style="background-color: #1988f9; height: 100%">
    <div class="login-page">
      <img src="/static/logo.png" height="50vh"
           style="display:block; margin: 0 auto"/>
      <br><br>
      <div class="form">
        <form v-on:submit.prevent="login" class="login-form">
          <input type="text" placeholder="username" v-model="form.username" required/>
          <input type="password" placeholder="password" v-model="form.password" required/>
          <button :disabled="isSending">{{ buttonText }}</button>
          <p class="message">{{ error }}</p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import sessionStorage from 'sessionstorage';
import {loginPath} from '../env';

export default {
  name: "login",
  data() {
    return {
      form: {
        username: '',
        password: ''
      },

      error: '',
      isSending: false,
    }
  },

  computed: {

    buttonText: function () {
      return this.isSending ? 'Autenticando...' : 'Enviar';
    }
  },


  methods: {

    login: function () {

      this.isSending = true;

      axios.post(loginPath + '/login/credentials', this.form).then(res => {


        this.isSending = true;

        let result = res.data;

        if (result.code === 100) {

          if (result.data.user.permissions['chat-web'].access) {

            sessionStorage.setItem('username', this.form.username);
            sessionStorage.setItem('password', this.form.password);
            sessionStorage.setItem('user', result.data.user.name);
            sessionStorage.setItem('shortNumber', result.data.user.shortNumber);
            sessionStorage.setItem('token', result.data.sessionToken);
            sessionStorage.setItem('awsCredentials', JSON.stringify(result.data.awsCredentials));
            sessionStorage.setItem('firebaseId', result.data.user.firebaseId);

            this.$router.replace({name: 'Home'});

          } else {
            this.error = 'Permisos insuficientes';
          }

        } else {
          this.error = result.data.msg;
        }
        this.isSending = false;
      })
    }
  }
}
</script>

<style scoped>

.login-page {

  width: 360px;
  padding: 8% 0 0;
  margin: auto;
}

.form {
  position: relative;
  z-index: 1;
  background: #FFFFFF;
  max-width: 360px;
  margin: 0 auto 100px;
  padding: 45px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}

.form input {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 15px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
}

.form button {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #1988f9;
  width: 100%;
  border: 0;
  padding: 15px;
  color: #FFFFFF;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}

.form button:disabled {
  cursor: not-allowed;
}

.form .message {
  margin: 15px 0 0;
  color: red;
  font-size: 12px;
}

.form .message a {
  color: #1988f9;
  text-decoration: none;
}

.form .register-form {
  display: none;
}

.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}

.container:before, .container:after {
  content: "";
  display: block;
  clear: both;
}

.container .info {
  margin: 50px auto;
  text-align: center;
}

.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}

.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}

.container .info span a {
  color: #000000;
  text-decoration: none;
}

.container .info span .fa {
  color: #EF3B3A;
}


</style>



// WEBPACK FOOTER //
// src/components/Login.vue